/* Small enhancements around Dawn's native gallery, product form and filters. */
(() => {
  function tabs(root, panelSelector) {
    if (root.dataset.vrReady) return;
    root.dataset.vrReady = 'true';
    const buttons = [...root.querySelectorAll('[role="tab"]')];
    function select(button) {
      buttons.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      root.querySelectorAll(panelSelector).forEach(panel => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(button));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { event.preventDefault(); select(buttons[next]); buttons[next].focus(); }
      });
    });
  }
  function purchase(root) {
    const info = root.querySelector('.product__info-container');
    if (!info || info.querySelector('.vr-purchase-row')) return;
    const qty = info.querySelector('.product-form__quantity');
    const form = info.querySelector('product-form');
    if (!qty || !form) return;
    const wrapper = form.parentElement;
    const row = document.createElement('div'); row.className = 'vr-purchase-row';
    wrapper.before(row); wrapper.classList.add('vr-buy-wrapper'); row.append(qty, wrapper);
    const pickup = wrapper.querySelector('pickup-availability');
    if (pickup) row.after(pickup);
  }
  function mobileTitle(root) {
    if (root.dataset.vrMobileTitleReady) return;
    const info = root.querySelector('.product__info-container');
    const title = info && info.querySelector('.product__title');
    const media = root.querySelector('.product__media-wrapper');
    if (!title || !media) return;
    root.dataset.vrMobileTitleReady = 'true';
    const originalPlace = document.createComment('VERORARO product title original position');
    title.before(originalPlace);
    const extended = info.querySelector('.vr-product-extended-title');
    const extendedPlace = document.createComment('VERORARO extended title original position');
    if (extended) extended.before(extendedPlace);
    const mobile = window.matchMedia('(max-width: 749px)');
    function placeTitle() {
      if (!root.isConnected) { mobile.removeEventListener('change', placeTitle); return; }
      if (mobile.matches) { media.before(title); title.classList.add('vr-mobile-product-title'); if (extended) { media.after(extended); extended.classList.add('vr-mobile-extended-title'); } }
      else { originalPlace.after(title); title.classList.remove('vr-mobile-product-title'); if (extended) { extendedPlace.after(extended); extended.classList.remove('vr-mobile-extended-title'); } }
    }
    mobile.addEventListener('change', placeTitle);
    placeTitle();
  }
  function groups(box) {
    if (box.dataset.vrReady) return;
    const wrapper = box.closest('.product__media-wrapper');
    const gallery = wrapper.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    box.dataset.vrReady = 'true';
    const data = JSON.parse(box.querySelector('.vr-gallery-data').textContent);
    const fieldsNode = box.querySelector('.vr-gallery-fields');
    const fields = fieldsNode ? JSON.parse(fieldsNode.textContent) : [[], [], [], []];
    const explicit = fields.map(ids => ids.map(id => data.find(media => String(media.id) === String(id))).filter(Boolean));
    const assigned = new Set(fields.flat().map(String));
    const sets = [[], [], [], []];
    let photoIndex = 0;
    data.forEach(media => {
      let group;
      if (['video', 'external_video'].includes(media.type)) group = 1;
      else if (media.type === 'image') {
        const marker = String(media.alt || '').match(/\[(presentazione|presentation|dettagli|details|difetti|flaws)\]/i);
        group = marker ? (/difetti|flaws/i.test(marker[1]) ? 3 : /dettagli|details/i.test(marker[1]) ? 2 : 0) : (photoIndex < 2 ? 0 : 2);
        photoIndex++;
      }
      media.group = group;
      if (group !== undefined && !assigned.has(String(media.id)) && !explicit[group].length) sets[group].push(media);
    });
    explicit.forEach((items, index) => { if (items.length) sets[index] = items; items.forEach(item => { item.group = index; }); });
    const modal = document.getElementById(box.dataset.modal);
    if (modal) modal.dataset.vrGallery = JSON.stringify(data.map(item => ({id: String(item.id), group: item.group})));
    const buttons = [...box.querySelectorAll('[role="tab"]')];
    const empty = box.querySelector('.vr-gallery-empty');
    buttons.forEach(button => button.setAttribute('aria-controls', gallery.id));
    gallery.setAttribute('role', 'tabpanel');
    function select(button) {
      const set = sets[Number(button.dataset.group)];
      buttons.forEach(tab => { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      gallery.setAttribute('aria-labelledby', button.id); gallery.hidden = !set.length; empty.hidden = !!set.length;
      const it = document.documentElement.lang.startsWith('it');
      const messages = it ? ['Nessuna foto di presentazione disponibile.', 'Nessun video disponibile.', 'Nessuna foto di dettaglio disponibile.', 'Nessuna foto delle condizioni disponibile.'] : ['No presentation photos available.', 'No video available.', 'No detail photos available.', 'No condition photos available.'];
      empty.textContent = messages[Number(button.dataset.group)];
      if (modal) modal.dataset.vrMediaIds = JSON.stringify(set.map(media => String(media.id)));
      const suffixes = new Set(set.map(media => String(media.id)));
      gallery.querySelectorAll('[data-media-id]').forEach(slide => { slide.hidden = !suffixes.has(slide.dataset.mediaId.split('-').pop()); });
      gallery.querySelectorAll('[data-target]').forEach(thumb => { thumb.hidden = !suffixes.has(thumb.dataset.target.split('-').pop()); });
      if (set.length) { const slide = [...gallery.querySelectorAll('[data-media-id]')].find(item => !item.hidden); gallery.setActiveMedia(slide.dataset.mediaId, false); }
      gallery.querySelectorAll('slider-component').forEach(slider => { if (typeof slider.resetPages === 'function') slider.resetPages(); });
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(button));
      button.addEventListener('keydown', event => {
        const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (delta) { event.preventDefault(); const next = buttons[(index + delta + buttons.length) % buttons.length]; select(next); next.focus(); }
      });
    });
    select(buttons[0]);
  }
  function lightbox(modal) {
    if (modal.dataset.vrReady) return;
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    const allMedia = [...content.children].filter(child => child.hasAttribute('data-media-id'));
    let media = allMedia;
    if (!media.length) return;
    modal.dataset.vrReady = 'true'; modal.classList.add('vr-lightbox', 'vr-progressive-lightbox', 'vr-fixed-focus');
    const it = document.documentElement.lang.startsWith('it');
    const dialog = modal.querySelector('[role="dialog"]');
    // Isolated A'dammer ALT trial, enabled only on this product in the draft theme.
    const altTrial = /\/products\/mobile-scrittoio-amsterdammer-a-van-den-nieuwelaar-per-pastoe-anni-70\/?$/.test(location.pathname);
    const caption = altTrial ? document.createElement('p') : null;
    if (caption) {
      modal.classList.add('vr-alt-trial');
      caption.className = 'vr-lightbox-alt'; caption.hidden = true;
      caption.setAttribute('aria-live', 'polite'); caption.setAttribute('aria-atomic', 'true');
      dialog.append(caption);
    }
    const category = document.createElement('div'); category.className = 'vr-lightbox-category'; category.setAttribute('aria-live', 'polite'); dialog.append(category);
    const categoryLabels = it ? ['Presentazione', 'Video', 'Dettagli', 'Condizioni', 'Misure'] : ['Presentation', 'Video', 'Details', 'Condition', 'Measurements'];
    const categoryMenu = document.createElement('div'); categoryMenu.className = 'vr-desktop-gallery-categories';
    categoryMenu.setAttribute('role', 'group'); categoryMenu.setAttribute('aria-label', it ? 'Sezioni della gallery' : 'Gallery sections');
    const categoryButtons = [0, 4, 2, 3].map(index => {
      const label = categoryLabels[index];
      const control = button(label, label); control.className = 'vr-desktop-category-button';
      control.setAttribute('aria-pressed', 'false'); control.dataset.group = String(index);
      control.addEventListener('click', event => {
        event.stopPropagation();
        const selected = allMedia.find(item => categoryIndex(item) === index);
        if (selected) show(0, selected);
      });
      categoryMenu.append(control); return control;
    });
    const desktopCount = document.createElement('span'); desktopCount.className = 'vr-desktop-gallery-count'; desktopCount.setAttribute('aria-live', 'polite');
    const desktopCountLabel = document.createElement('span'); desktopCountLabel.className = 'vr-desktop-count-label'; desktopCountLabel.textContent = it ? 'Foto' : 'Photo';
    const desktopCountNumber = document.createElement('strong'); desktopCountNumber.className = 'vr-desktop-count-number';
    desktopCount.append(desktopCountLabel, desktopCountNumber);
    const galleryVideos = allMedia.filter(item => item.tagName === 'DEFERRED-MEDIA');
    const galleryVideo = button('', galleryVideos.length ? (it ? 'Apri video del prodotto' : 'Open product video') : (it ? 'Nessun video disponibile' : 'No video available'));
    galleryVideo.className = 'vr-gallery-video-shortcut';
    galleryVideo.disabled = !galleryVideos.length;
    const sourceVideoIcon = document.querySelector('.vr-product-video-action svg');
    if (sourceVideoIcon) galleryVideo.append(sourceVideoIcon.cloneNode(true));
    else galleryVideo.innerHTML = '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false"><circle cx="24" cy="24" r="23" stroke="currentColor" stroke-width="1"/><rect x="10" y="17" width="20" height="14" rx="2.5" fill="currentColor"/><path d="m31 21 8-5v16l-8-5Z" fill="currentColor"/></svg>';
    const galleryVideoLabel = document.createElement('span');
    galleryVideoLabel.textContent = galleryVideos.length + ' ' + (it || galleryVideos.length === 1 ? 'video' : 'videos');
    galleryVideo.append(galleryVideoLabel);
    galleryVideo.addEventListener('click', event => { event.stopPropagation(); if (galleryVideos[0]) void show(0, galleryVideos[0]); });
    desktopCount.append(galleryVideo);
    const desktopAlt = document.createElement('p'); desktopAlt.className = 'vr-desktop-photo-alt'; desktopAlt.hidden = true;
    dialog.append(categoryMenu, desktopCount, desktopAlt);
    desktopAlt.addEventListener('pointerup',event=>event.stopPropagation());
    function categoryIndex(item) {
      const catalog = modal.dataset.vrGallery ? JSON.parse(modal.dataset.vrGallery) : [];
      return catalog.find(entry => entry.id === item.dataset.mediaId)?.group ?? 0;
    }
    function button(text, label) { const el = document.createElement('button'); el.type = 'button'; el.textContent = text; el.setAttribute('aria-label', label); return el; }
    const nav = document.createElement('div'); nav.className = 'vr-lightbox-nav vr-lightbox-toolbar';
    const prev = button('\u2039', it ? 'Foto precedente' : 'Previous photo');
    const next = button('\u203a', it ? 'Foto successiva' : 'Next photo');
    const count = document.createElement('span'); count.className = 'vr-lightbox-count'; count.setAttribute('aria-live', 'polite');
    const previousTool = document.createElement('div'); previousTool.className = 'vr-photo-step';
    const previousArrow = document.createElement('span'); previousArrow.className = 'vr-photo-arrow'; previousArrow.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 4 6 12l12 8"/></svg>'; previousArrow.setAttribute('aria-hidden', 'true'); prev.replaceChildren(previousArrow); previousTool.append(prev);
    const nextTool = document.createElement('div'); nextTool.className = 'vr-photo-step';
    const nextArrow = document.createElement('span'); nextArrow.className = 'vr-photo-arrow'; nextArrow.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 4 12 8-12 8"/></svg>'; nextArrow.setAttribute('aria-hidden', 'true'); next.replaceChildren(nextArrow); nextTool.append(next);
    dialog.append(nav);
    const controls = document.createElement('div'); controls.className = 'vr-zoom-controls'; controls.hidden = true;
    const lens = button('', it ? 'Attiva lente circolare' : 'Activate magnifying lens');
    lens.className = 'vr-zoom-lens'; lens.setAttribute('aria-pressed', 'false');
    lens.innerHTML = '<svg class="vr-gallery-lens-symbol" viewBox="0 0 450 450" aria-hidden="true"><path fill-rule="evenodd" d="M172 30a148 148 0 1 0 0 296 148 148 0 0 0 0-296Zm0 12a136 136 0 1 1 0 272 136 136 0 0 1 0-272Z"/><path d="M175 303c64-13 106-57 121-125 0 68-48 120-121 125ZM307 253l59 59-47 47-53-54ZM376 322l49 49-47 49-50-51Z"/></svg>';
    const lensTool = document.createElement('div'); lensTool.className = 'vr-zoom-tool vr-zoom-lens-tool';
    const lensLabel = document.createElement('span'); lensLabel.className = 'vr-zoom-caption'; lensLabel.textContent = it ? 'Lente' : 'Lens';
    lensTool.append(lens, lensLabel);
    const zoomTool = document.createElement('div'); zoomTool.className = 'vr-zoom-tool vr-zoom-step-tool';
    const zoomIn = button('+', it ? 'Ingrandisci foto' : 'Zoom in'); zoomIn.className = 'vr-zoom-step vr-zoom-in';
    const zoomOut = button('−', it ? 'Riduci foto' : 'Zoom out'); zoomOut.className = 'vr-zoom-step vr-zoom-out';
    const zoomLabel = document.createElement('span'); zoomLabel.className = 'vr-zoom-caption'; zoomLabel.textContent = 'zoom';
    zoomTool.append(zoomOut, zoomLabel, zoomIn);
    const level = document.createElement('output'); level.className = 'vr-zoom-level'; level.textContent = '1\u00d7'; level.setAttribute('aria-live', 'polite');
    const browseTool = document.createElement('div'); browseTool.className = 'vr-gallery-browse';
    const browseLabel = document.createElement('span'); browseLabel.className = 'vr-gallery-browse-label'; browseLabel.textContent = it ? 'sfoglia' : 'browse';
    browseTool.append(previousTool, browseLabel, nextTool);
    controls.append(zoomTool, level); nav.append(controls, browseTool);
    const wordmarkSource = document.querySelector('.header .vr-design-wordmark-image')?.src || document.querySelector('script[data-vr-account-access]')?.dataset.logo;
    const wordmark = document.createElement('img'); wordmark.className = 'vr-lightbox-wordmark'; wordmark.alt = 'VERORARO'; wordmark.width = 150; wordmark.height = 23;
    if (wordmarkSource) wordmark.src = wordmarkSource;
    wordmark.hidden = !wordmarkSource;
    const photoHeader = document.createElement('div'); photoHeader.className = 'vr-lightbox-header';
    const headerRow = document.createElement('div'); headerRow.className = 'vr-lightbox-header-row';
    headerRow.append(lensTool, category);
    const closeControl = dialog.querySelector('.product-media-modal__toggle'); if (closeControl) headerRow.append(closeControl);
    const brand = document.createElement('div'); brand.className = 'vr-lightbox-brand';
    const galleryLabel = document.createElement('span'); galleryLabel.className = 'vr-gallery-label'; galleryLabel.textContent = 'gallery';
    const brandLink = document.createElement('a'); brandLink.className = 'vr-lightbox-home-link';
    brandLink.href = document.querySelector('.header .header__heading-link')?.href || '/';
    brandLink.setAttribute('aria-label', it ? 'Vai alla home VERORARO' : 'VERORARO home');
    brandLink.append(wordmark, galleryLabel); brand.append(brandLink);
    photoHeader.append(brand, headerRow); dialog.append(photoHeader);
    const magnifier = document.createElement('div'); magnifier.className = 'vr-detail-lens'; magnifier.hidden = true; magnifier.setAttribute('role', 'presentation'); dialog.append(magnifier);
    function moveLens(clientX, clientY) {
      const img = image(); if (!selecting || !img) { magnifier.hidden = true; return; }
      const rect = img.getBoundingClientRect(); const area = content.getBoundingClientRect();
      const visible = {left:Math.max(rect.left, area.left), right:Math.min(rect.right, area.right), top:Math.max(rect.top, area.top), bottom:Math.min(rect.bottom, area.bottom)};
      if (window.matchMedia('(min-width:990px)').matches) {
        if (visible.right <= visible.left || visible.bottom <= visible.top) { magnifier.hidden = true; return; }
        // Pointer capture keeps a desktop drag alive at the clipped photograph edges.
        clientX = Math.max(visible.left, Math.min(visible.right, clientX));
        clientY = Math.max(visible.top, Math.min(visible.bottom, clientY));
      } else if (clientX < visible.left || clientX > visible.right || clientY < visible.top || clientY > visible.bottom) { magnifier.hidden = true; return; }
      const small = window.matchMedia('(max-width:749px)').matches;
      const baseDiameter = small ? Math.min(300, window.innerWidth - 40, Math.max(230, content.clientWidth * .8)) : Math.min(255, Math.max(165, content.clientWidth * .42));
      const diameter = baseDiameter * 1.08; // 10% smaller than the previous 1.2 multiplier.
      lensX = clientX; lensY = clientY;
      const power = (Math.max(1, Math.min(3.2, img.naturalWidth / rect.width * 1.25)) * 1.8);
      magnifier.style.width = magnifier.style.height = diameter + 'px';
      magnifier.style.left = clientX + 'px'; magnifier.style.top = clientY + 'px';
      magnifier.style.backgroundImage = 'url("' + img.currentSrc + '")';
      magnifier.style.backgroundSize = (rect.width * power) + 'px ' + (rect.height * power) + 'px';
      magnifier.style.backgroundPosition = (diameter / 2 - (clientX - rect.left) * power) + 'px ' + (diameter / 2 - (clientY - rect.top) * power) + 'px';
      magnifier.hidden = false;
    }
    [nav, controls, photoHeader].forEach(el => el.addEventListener('pointerup', event => event.stopPropagation()));
    let mobileZoom = 1;
    const compactGallery = () => !window.matchMedia('(min-width:990px)').matches;
    let scale = 1, limit = 3, baseW = 0, baseH = 0, offsetX = 0, offsetY = 0, focusX = .5, focusY = 0, selecting = false, drag, swipe, lensDrag, lensX = 0, lensY = 0;
    magnifier.addEventListener('pointerdown', event => {
      if (!selecting || event.button !== 0) return;
      lensDrag = {id:event.pointerId, dx:lensX - event.clientX, dy:lensY - event.clientY};
      const radius = magnifier.getBoundingClientRect().width / 2;
      if (event.pointerType !== 'mouse' && Math.hypot(lensDrag.dx, lensDrag.dy) < radius - 24) {
        lensDrag.dx = 0; lensDrag.dy = -radius + 8;
        const r = image()?.getBoundingClientRect();
        if (r) moveLens(Math.max(r.left, Math.min(r.right, event.clientX)), Math.max(r.top, Math.min(r.bottom, event.clientY + lensDrag.dy)));
      }
      magnifier.setPointerCapture(event.pointerId); event.preventDefault(); event.stopPropagation();
    });
    magnifier.addEventListener('pointermove', event => {
      if (!lensDrag || lensDrag.id !== event.pointerId) return;
      const r = image()?.getBoundingClientRect(); if (!r) return;
      moveLens(Math.max(r.left, Math.min(r.right, event.clientX + lensDrag.dx)), Math.max(r.top, Math.min(r.bottom, event.clientY + lensDrag.dy)));
      event.preventDefault();
    });
    ['pointerup', 'pointercancel'].forEach(type => magnifier.addEventListener(type, event => { lensDrag = undefined; event.stopPropagation(); }));
    function activeIndex() { return Math.max(0, media.findIndex(item => item.classList.contains('active'))); }
    function image() { const el = media[activeIndex()]; return el.tagName === 'IMG' ? el : null; }
    function bounds() { return {x: Math.max(0, (baseW * scale - content.clientWidth) / 2), y: Math.max(0, baseH * scale - content.clientHeight)}; }
    function paint() {
      const img = image(); if (!img) return;
      const b = bounds(); offsetX = Math.max(-b.x, Math.min(b.x, offsetX)); offsetY = Math.max(-b.y, Math.min(0, offsetY));
      img.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
      level.textContent = Number(scale.toFixed(2)) + '\u00d7';
      level.setAttribute('aria-label', (it ? 'Ingrandimento ' : 'Zoom ') + level.textContent);
      zoomIn.disabled = scale >= limit - .001; zoomOut.disabled = scale <= 1;
      modal.classList.toggle('vr-zoomed', scale > 1); modal.classList.toggle('vr-select-detail', selecting);
      placeControls();
    }
    function placeControls() {
      modal.style.setProperty('--vr-photo-header-height', photoHeader.getBoundingClientRect().height + 'px');
      const img = image(); if (!img || !img.naturalWidth) return;
      const area = content.getBoundingClientRect(), rect = img.getBoundingClientRect();
      if(compactGallery()){
        modal.style.setProperty('--vr-photo-toolbar-left',area.left+'px');
        modal.style.setProperty('--vr-photo-toolbar-width',area.width+'px');
        modal.style.setProperty('--vr-photo-toolbar-top',(area.bottom+8)+'px');
        modal.style.setProperty('--vr-photo-caption-top',(area.bottom+60)+'px');
        return;
      }
      const visibleWidth = Math.max(0, Math.min(area.right, rect.right) - Math.max(area.left, rect.left));
      const toolbarWidth = Math.min(area.width, Math.max(296, visibleWidth));
      const toolbarLeft = Math.max(area.left, Math.min((rect.left + rect.right - toolbarWidth) / 2, area.right - toolbarWidth));
      modal.style.setProperty('--vr-photo-toolbar-left', toolbarLeft + 'px');
      modal.style.setProperty('--vr-photo-toolbar-width', toolbarWidth + 'px');
      modal.style.setProperty('--vr-photo-toolbar-top', Math.min(rect.bottom, area.bottom) + 10 + 'px');
    }
    function fit(resetZoom = true, keepMobileZoom = false) {
      const img = image(); controls.hidden = !img || !img.naturalWidth;
      modal.classList.toggle('vr-mobile-fixed-photo',compactGallery() && !!img);
      wordmark.hidden = !wordmarkSource; lensTool.hidden = controls.hidden;
      galleryLabel.textContent = window.matchMedia('(min-width:990px)').matches ? (it ? 'foto gallery' : 'photo gallery') : 'gallery';
      modal.classList.toggle('vr-photo-loading', !!img && !img.naturalWidth);
      if (!img || !img.naturalWidth) return;
      const small = window.matchMedia('(max-width:749px)').matches;
      const oldWidth = altTrial ? content.clientWidth : window.innerWidth - (small ? 70 : 128);
      const oldHeight = altTrial ? content.clientHeight : window.innerHeight - (small ? 196 : 180);
      const desktopPhoto = window.matchMedia('(min-width:990px)').matches;
      const factor = desktopPhoto
        ? Math.min(1, Math.max(window.innerHeight * 1.1 / img.naturalHeight, content.clientWidth / img.naturalWidth, content.clientHeight / img.naturalHeight))
        : Math.min(Math.min(oldWidth / img.naturalWidth, oldHeight / img.naturalHeight, 1) * (altTrial ? 1 : 1.4), 1, content.clientWidth / img.naturalWidth, content.clientHeight / img.naturalHeight);
      baseW = img.naturalWidth * factor; baseH = img.naturalHeight * factor;
      limit = Math.max(1, Math.min(3, 1 / factor)); lens.disabled = limit <= 1;
      img.style.width = baseW + 'px'; img.style.height = baseH + 'px';
      if (resetZoom) {
        magnifier.hidden = true; scale = keepMobileZoom ? Math.min(mobileZoom, limit) : 1; offsetX = 0;
        if (!keepMobileZoom) mobileZoom = 1;
        offsetY = desktopPhoto ? Math.min(0, (content.clientHeight - baseH) / 2) : 0;
        focusX = .5; focusY = desktopPhoto ? -offsetY / baseH : 0;
        selecting = false; lens.setAttribute('aria-pressed', 'false');
      }
      scale = Math.min(scale, limit); paint();
    }
    function setZoom(value) {
      magnifier.hidden = true; selecting = false; lens.setAttribute('aria-pressed', 'false'); scale = Math.max(1, Math.min(limit, value));
      if (compactGallery()) mobileZoom = scale;
      offsetX = (.5 - focusX) * baseW * scale; offsetY = -focusY * baseH * scale; paint();
    }
    let changeRequest = 0, requestedIndex;
    function preparePhoto(img) {
      img.loading = 'eager';
      if (img.complete && img.naturalWidth > 0) return Promise.resolve(true);
      return img.decode().then(() => img.naturalWidth > 0).catch(() => false);
    }
    function preloadNeighbours() {
      if (media.length < 2 || !image()) return;
      (compactGallery() ? [-2,-1,1,2] : [-1,1]).forEach(delta => {
        const item = media[(activeIndex() + delta + media.length) % media.length];
        if (item.tagName === 'IMG') preparePhoto(item);
      });
    }
    function update(keepMobileZoom = false) {
      const activeVideo = allMedia.find(item => item.classList.contains('active') && item.tagName !== 'IMG');
      media = activeVideo ? [activeVideo] : allMedia.filter(item => item.tagName === 'IMG').sort((a, b) => categoryIndex(a) - categoryIndex(b));
      if (caption) {
        const text = image()?.getAttribute('alt')?.replace(/&nbsp;/gi, ' ').trim() || '';
        caption.textContent = text; caption.hidden = !text;
        modal.classList.toggle('vr-alt-has-caption', !!text);
      }
      nav.hidden = !!activeVideo;
      nav.style.display = activeVideo ? 'none' : 'flex';
      if (!media.length) { controls.hidden = true; lensTool.hidden = true; count.textContent = '0 / 0'; return; }
      if (!media.some(item => item.classList.contains('active'))) { allMedia.forEach(item => item.classList.toggle('active', item === media[0])); }
      count.textContent = (activeIndex() + 1) + ' / ' + media.length;
      const activeGroup = categoryIndex(media[activeIndex()]);
      category.replaceChildren(document.createTextNode(categoryLabels[activeGroup]), count);
      categoryButtons.forEach(control => {
        const index = Number(control.dataset.group);
        const available = allMedia.some(item => categoryIndex(item) === index);
        control.disabled = !available; control.setAttribute('aria-pressed', String(index === activeGroup));
      });
      desktopCountNumber.textContent = count.textContent.replace(/\s*\/\s*/, '/');
      const altText = image()?.getAttribute('alt')?.trim() || '';
      desktopAlt.textContent = altText; desktopAlt.hidden = !altText;
      sidePrev.hidden = sideNext.hidden = !!activeVideo;
      fit(true, keepMobileZoom); preloadNeighbours();
    }
    const photoAnimations = new Set(); let swipeLayer, neighbourLayer, gestureFrame, latestGesture;
    function trackAnimation(animation) {
      photoAnimations.add(animation);
      animation.finished.catch(() => {}).finally(() => photoAnimations.delete(animation));
      return animation;
    }
    function clearPhotoMotion() {
      photoAnimations.forEach(animation => animation.cancel()); photoAnimations.clear();
      swipeLayer?.remove(); swipeLayer = undefined;
      neighbourLayer?.remove(); neighbourLayer = undefined;
      content.classList.remove('vr-swipe-committing');
    }
    function motionAllowed() { return compactGallery() && !window.matchMedia('(prefers-reduced-motion:reduce)').matches && typeof image()?.animate === 'function'; }
    function outgoingPhotoLayer() {
      if (!motionAllowed() || !image()) return null;
      const rect = image().getBoundingClientRect(), area = content.getBoundingClientRect();
      const layer = document.createElement('div'), copy = image().cloneNode(false);
      layer.className = 'vr-gallery-swipe-layer'; layer.setAttribute('aria-hidden', 'true');
      Object.assign(layer.style, {left:area.left+'px',top:area.top+'px',width:area.width+'px',height:area.height+'px'});
      copy.removeAttribute('id'); copy.removeAttribute('data-media-id'); copy.removeAttribute('srcset'); copy.removeAttribute('sizes');
      copy.src = image().currentSrc || image().src; copy.alt = ''; copy.className = 'vr-gallery-swipe-image';
      copy.style.cssText = '';
      Object.assign(copy.style, {left:(rect.left-area.left)+'px',top:(rect.top-area.top)+'px',width:rect.width+'px',height:rect.height+'px'});
      layer.append(copy); dialog.append(layer); swipeLayer = layer; return {layer,copy};
    }
    function beginPhotoChange(delta, distance) {
      neighbourLayer?.remove(); neighbourLayer=undefined;
      const outgoing=outgoingPhotoLayer(); if(!outgoing){paint();return null;}
      outgoing.distance=Math.max(-content.clientWidth*.95,Math.min(content.clientWidth*.95,distance));
      outgoing.started=performance.now();
      content.classList.add('vr-swipe-committing');
      const motion=trackAnimation(outgoing.copy.animate([{transform:'translateX(0px)'},{transform:'translateX('+(-delta*content.clientWidth-outgoing.distance)+'px)'}],{duration:180,easing:'cubic-bezier(.2,.7,.2,1)',fill:'forwards'}));
      outgoing.motion=motion;return outgoing;
    }
    function animatePhotoChange(outgoing, delta) {
      content.classList.remove('vr-swipe-committing');
      if (!outgoing) return;
      const img=image(),elapsed=performance.now()-outgoing.started,width=content.clientWidth;
      if(!img){clearPhotoMotion();return;}
      const late=elapsed>=180,options={duration:late?140:180,easing:'cubic-bezier(.2,.7,.2,1)'};
      const incoming=trackAnimation(img.animate([
        {transform:'translate('+(offsetX+delta*width+(late?0:outgoing.distance))+'px, '+offsetY+'px) scale('+scale+')'},
        {transform:img.style.transform}
      ],options));
      if(!late)incoming.currentTime=elapsed;
      incoming.finished.catch(()=>{}).finally(()=>{
        outgoing.motion.cancel();outgoing.layer.remove();if(swipeLayer===outgoing.layer)swipeLayer=undefined;
      });
    }
    function previewNeighbour(distance) {
      if(!compactGallery() || !distance || media.length<2)return;
      const delta=distance<0?1:-1,target=media[(activeIndex()+delta+media.length)%media.length];
      if(target.tagName!=='IMG' || !target.complete || !target.naturalWidth)return;
      if(neighbourLayer?.dataset.direction!==String(delta)){
        neighbourLayer?.remove();
        const area=content.getBoundingClientRect(),layer=document.createElement('div'),copy=target.cloneNode(false);
        layer.className='vr-gallery-swipe-layer';layer.dataset.direction=String(delta);layer.setAttribute('aria-hidden','true');
        Object.assign(layer.style,{left:area.left+'px',top:area.top+'px',width:area.width+'px',height:area.height+'px'});
        copy.removeAttribute('id');copy.removeAttribute('data-media-id');copy.removeAttribute('srcset');copy.removeAttribute('sizes');copy.src=target.currentSrc||target.src;copy.alt='';copy.className='vr-gallery-swipe-image';copy.style.cssText='';
        const factor=Math.min(area.width/target.naturalWidth,area.height/target.naturalHeight,1),z=Math.min(scale,1/factor,3),w=target.naturalWidth*factor*z,h=target.naturalHeight*factor*z;
        Object.assign(copy.style,{left:(area.width-w)/2+'px',top:'0px',width:w+'px',height:h+'px'});
        layer.append(copy);dialog.append(layer);neighbourLayer=layer;
      }
      neighbourLayer.firstElementChild.style.transform='translateX('+(delta*content.clientWidth+distance)+'px)';
    }
    function settlePhoto() {
      neighbourLayer?.remove();neighbourLayer=undefined;
      const img = image(), from = img?.style.transform; paint();
      if (img && from !== img.style.transform && motionAllowed()) trackAnimation(img.animate([{transform:from},{transform:img.style.transform}],{duration:140,easing:'ease-out'}));
    }
    function trackGesture(gesture, event) {
      const dx = event.clientX-gesture.x, dy = event.clientY-gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx),Math.abs(dy)) > 8) {
        if (Math.abs(dx) > Math.abs(dy)*1.1) gesture.axis = 'x';
        else if (Math.abs(dy) > Math.abs(dx)*1.1) gesture.axis = 'y';
      }
      const step = event.clientX-gesture.lastX;
      if (step) { gesture.velocity = step/Math.max(1,event.timeStamp-gesture.lastT); gesture.lastX=event.clientX;gesture.lastT=event.timeStamp; }
      return {dx,dy};
    }
    function commitsSwipe(gesture, distance, event) {
      if (!compactGallery()) return Math.abs(distance)>=Math.max(35,Math.min(60,content.clientWidth*.15)) && Math.abs(distance)>Math.abs(event.clientY-gesture.y)*1.3;
      const threshold = Math.max(28,Math.min(48,content.clientWidth*.12));
      const flick = Math.abs(distance)>=14 && event.timeStamp-gesture.lastT<120 && Math.abs(gesture.velocity)>.45 && Math.sign(gesture.velocity)===Math.sign(distance);
      return gesture.axis === 'x' && (Math.abs(distance)>=threshold || flick);
    }
    async function show(delta, selectedTarget = null, fromSwipe = false) {
      if (!selectedTarget && (media.length < 2 || !image())) return;
      const targetPool = selectedTarget
        ? (selectedTarget.tagName === 'IMG' ? allMedia.filter(item => item.tagName === 'IMG').sort((a, b) => categoryIndex(a) - categoryIndex(b)) : [selectedTarget])
        : media;
      const index = selectedTarget ? targetPool.indexOf(selectedTarget) : ((requestedIndex ?? activeIndex()) + delta + media.length) % media.length;
      if (index < 0) return;
      clearPhotoMotion(); requestedIndex = index;
      const request = ++changeRequest, selected = targetPool[index];
      // The lens must never intercept navigation while the next photo loads.
      magnifier.hidden = true; lensDrag = undefined;
      nav.setAttribute('aria-busy', 'true'); count.textContent = (index + 1) + ' / ' + targetPool.length + ' …';
      // Finish the released movement immediately, independently of network/decode time.
      const outgoing=fromSwipe ? beginPhotoChange(delta,fromSwipe.distance||0) : null;
      let loadTimer;
      const ready=selected.tagName==='IMG' ? await Promise.race([preparePhoto(selected),new Promise(resolve=>{loadTimer=setTimeout(()=>resolve(false),6000);})]) : true;
      clearTimeout(loadTimer);
      if (request !== changeRequest || !modal.hasAttribute('open')) return;
      nav.removeAttribute('aria-busy');
      requestedIndex = undefined;
      if (!ready) { clearPhotoMotion(); count.textContent = (activeIndex() + 1) + ' / ' + media.length; settlePhoto(); return; }
      const keepZoom = compactGallery() && !!image() && selected.tagName === 'IMG';

      window.pauseAllMedia();
      allMedia.forEach(item => item.classList.toggle('active', item === selected));
      update(keepZoom); animatePhotoChange(outgoing, delta);
    }
    prev.addEventListener('click', event => { event.stopPropagation(); show(-1); }); next.addEventListener('click', event => { event.stopPropagation(); show(1); });
    // Desktop side arrows share the same navigation routine as the compact controls.
    const sidePrev = button('', it ? 'Foto precedente (laterale)' : 'Previous photo (side)');
    const sideNext = button('', it ? 'Foto successiva (laterale)' : 'Next photo (side)');
    sidePrev.className = 'vr-desktop-photo-arrow vr-desktop-photo-prev';
    sideNext.className = 'vr-desktop-photo-arrow vr-desktop-photo-next';
    sidePrev.append(previousArrow.cloneNode(true)); sideNext.append(nextArrow.cloneNode(true));
    [sidePrev, sideNext].forEach(control => control.addEventListener('pointerup', event => event.stopPropagation()));
    sidePrev.addEventListener('click', event => { event.stopPropagation(); show(-1); });
    sideNext.addEventListener('click', event => { event.stopPropagation(); show(1); });
    dialog.append(sidePrev, sideNext);
    // Dawn closes media modals on mouse pointerup: interior desktop actions stay in the dialog.
    dialog.addEventListener('pointerup', event => {
      if (window.matchMedia('(min-width:990px)').matches) event.stopPropagation();
    });
    zoomIn.addEventListener('click', () => setZoom(scale + .2));
    zoomOut.addEventListener('click', () => setZoom(scale - .2));

    lens.addEventListener('click', () => {
      selecting = !selecting; lens.setAttribute('aria-pressed', String(selecting)); paint();
      if (selecting && image()) { const r = image().getBoundingClientRect(); moveLens(r.left + r.width / 2, r.top + r.height / 2); }
      else magnifier.hidden = true;
    });
    const lensDismissEvents = new WeakSet(), gesturePointers = new Set();
    // Dismiss on the first press outside the circular lens, without moving it there.
    modal.addEventListener('pointerdown', event => {
      if (!selecting || lensTool.contains(event.target)) return;
      const r = magnifier.getBoundingClientRect();
      const inside = !magnifier.hidden && Math.hypot(event.clientX - (r.left + r.width / 2), event.clientY - (r.top + r.height / 2)) <= r.width / 2;
      if (inside) return;
      lensDismissEvents.add(event); selecting = false; lensDrag = drag = swipe = undefined;
      magnifier.hidden = true; lens.setAttribute('aria-pressed', 'false'); paint();
    }, {capture:true});
    content.addEventListener('dragstart', event => event.preventDefault());
    content.addEventListener('pointerdown', event => {
      if (!image() || event.button !== 0) return;
      if (lensDismissEvents.has(event) || requestedIndex !== undefined) { event.preventDefault(); return; }
      clearPhotoMotion(); gesturePointers.add(event.pointerId);
      if (gesturePointers.size > 1) { swipe = drag = undefined; paint(); return; }
      const r = image().getBoundingClientRect();
      const gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,lastX:event.clientX,lastT:event.timeStamp,velocity:0,axis:null};
      if (selecting) {
        const touch = event.pointerType !== 'mouse', radius = magnifier.getBoundingClientRect().width/2;
        lensDrag = {id:event.pointerId,dx:0,dy:touch ? -radius+8 : 0};
        moveLens(Math.max(r.left,Math.min(r.right,event.clientX)),Math.max(r.top,Math.min(r.bottom,event.clientY+lensDrag.dy)));
      } else if (scale>1 || baseW>content.clientWidth || baseH>content.clientHeight) {
        drag = {...gesture,ox:offsetX,oy:offsetY,edgeSwipe:0};
      } else if (media.length>1) swipe=gesture;
      content.setPointerCapture(event.pointerId); event.preventDefault();
    });
    function moveGesture(event) {
      if (gesturePointers.size>1) return;
      if (selecting) {
        if (!lensDrag || lensDrag.id!==event.pointerId) return;
        const r=image()?.getBoundingClientRect();if(!r)return;
        moveLens(Math.max(r.left,Math.min(r.right,event.clientX+(lensDrag.dx||0))),Math.max(r.top,Math.min(r.bottom,event.clientY+(lensDrag.dy||0))));return;
      }
      if (swipe?.id===event.pointerId) {
        const {dx}=trackGesture(swipe,event);
        if(swipe.axis==='x'){image().style.transform='translate('+dx+'px, 0px) scale(1)';previewNeighbour(dx);}return;
      }
      if(!drag || drag.id!==event.pointerId)return;
      const {dx,dy}=trackGesture(drag,event), rawX=drag.ox+dx, b=bounds();
      offsetX=rawX;offsetY=drag.oy+dy;paint();
      focusX=.5-offsetX/(baseW*scale);focusY=-offsetY/(baseH*scale);
      drag.edgeSwipe=compactGallery() && drag.axis==='x' ? rawX-Math.max(-b.x,Math.min(b.x,rawX)) : 0;
      if(drag.edgeSwipe && media.length>1){image().style.transform='translate('+(offsetX+drag.edgeSwipe*.6)+'px, '+offsetY+'px) scale('+scale+')';previewNeighbour(drag.edgeSwipe*.6);}
    }
    function flushGesture(){cancelAnimationFrame(gestureFrame);gestureFrame=undefined;if(latestGesture){const event=latestGesture;latestGesture=undefined;moveGesture(event);}}
    content.addEventListener('pointermove',event=>{if(!swipe&&!drag&&!lensDrag)return;event.preventDefault();if(swipe||drag)trackGesture(swipe||drag,event);latestGesture=event;if(!gestureFrame)gestureFrame=requestAnimationFrame(()=>{gestureFrame=undefined;flushGesture();});});
    content.addEventListener('pointerup', event => {
      flushGesture();event.stopPropagation();gesturePointers.delete(event.pointerId);
      const gesture=swipe?.id===event.pointerId ? swipe : null, pan=drag?.id===event.pointerId ? drag : null;
      swipe=drag=lensDrag=undefined;
      const distance=gesture ? event.clientX-gesture.x : pan?.edgeSwipe || 0, candidate=gesture || pan;
      if(candidate && media.length>1 && commitsSwipe(candidate,distance,event)) {
        // Keep the released image in place until its decoded neighbour is ready.
        show(distance<0 ? 1 : -1,null,{distance:gesture ? distance : distance*.6});return;
      }
      if(gesture || pan)settlePhoto();
    });
    content.addEventListener('pointercancel', event => {cancelAnimationFrame(gestureFrame);gestureFrame=undefined;latestGesture=undefined;gesturePointers.delete(event.pointerId);swipe=drag=lensDrag=undefined;magnifier.hidden=true;settlePhoto();});
    content.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && event.relatedTarget !== magnifier && !lensDrag) magnifier.hidden = true; });
    content.addEventListener('wheel', event => { if (!image() || limit <= 1) return; event.preventDefault(); setZoom(scale + (event.deltaY < 0 ? .1 : -.1)); }, {passive:false});

    modal.addEventListener('keydown', event => { if (controls.contains(event.target)) return; if (event.key === 'ArrowRight') { event.preventDefault(); show(1); } if (event.key === 'ArrowLeft') { event.preventDefault(); show(-1); } });
    // Pointer gestures handle touch, pen and mouse once; no duplicate touchend navigation.
    media.filter(item => item.tagName === 'IMG').forEach(img => img.addEventListener('load', () => { if (img === image()) fit(false); }));
    new ResizeObserver(() => { if (modal.hasAttribute('open')) fit(false); }).observe(content);
    new MutationObserver(() => { cancelAnimationFrame(gestureFrame);gestureFrame=undefined;latestGesture=undefined;clearPhotoMotion(); gesturePointers.clear(); swipe = drag = lensDrag = undefined; changeRequest++; requestedIndex = undefined; nav.removeAttribute('aria-busy'); if (modal.hasAttribute('open')) update(); }).observe(modal, {attributes:true, attributeFilter:['open']});
    // Warm the first full-size photo before opening, rather than fetching it after the tap.
    const firstPhoto = allMedia.find(item => item.tagName === 'IMG');
    if (firstPhoto) preparePhoto(firstPhoto);
  }
  function collectionTitle() {
    const title = document.querySelector('.collection-hero__title'); if (!title) return;
    if (!title.dataset.originalTitle) title.dataset.originalTitle = title.textContent.trim().replace(/^(Collezione|Collection):\s*/i, '');
    document.querySelectorAll('.active-facets__button-remove span').forEach(label => { const text = document.documentElement.lang.startsWith('it') ? 'Azzera filtri' : 'Clear filters'; if (label.textContent !== text) label.textContent = text; });
    const filters = new URLSearchParams(location.search).getAll('filter.p.product_type');
    const categoryNames = {Lampade:'Illuminazione', 'Divani e Poltrone':'Salotto', Mobili:'Mobili e storage', Accessori:'Oggetti di design'};
    const categoryLabel = filters.includes('Tavoli') && filters.includes('Sedie') ? 'Tavoli e sedie' : filters.map(value => categoryNames[value] || value).join(' \u00b7 ');
    const selectedTitle = filters.length ? categoryLabel : (/^prodott[oi] disponibili$/i.test(title.dataset.originalTitle) ? (document.documentElement.lang.startsWith('it') ? 'Catalogo' : 'Catalogue') : title.dataset.originalTitle);
    if (title.textContent !== selectedTitle) title.textContent = selectedTitle;
    document.querySelectorAll('.active-facets__button').forEach(link => { if (link.href && new URL(link.href).searchParams.getAll('filter.p.product_type').length < filters.length) link.hidden = true; });
  }
  function filterControls() {
    const root = document.querySelector('#main-collection-filters'), title = document.querySelector('.collection-hero__title');
    if (!root || !title || root.dataset.vrObserved) return;
    root.dataset.vrObserved = 'true';
    const it = document.documentElement.lang.startsWith('it');
    const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'vr-filter-toggle';
    toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('aria-controls', 'FacetsWrapperDesktop');
    toggle.textContent = it ? 'Nascondi filtri' : 'Hide filters';
    toggle.addEventListener('click', () => {
      const wrapper = root.querySelector('#FacetsWrapperDesktop'); if (!wrapper) return;
      wrapper.hidden = !wrapper.hidden; toggle.setAttribute('aria-expanded', String(!wrapper.hidden));
      toggle.textContent = wrapper.hidden ? (it ? 'Mostra filtri' : 'Show filters') : (it ? 'Nascondi filtri' : 'Hide filters');
    });
    title.after(toggle);
    let pending;
    new MutationObserver(() => { clearTimeout(pending); pending = setTimeout(() => { const wrapper = root.querySelector('#FacetsWrapperDesktop'); if (wrapper) wrapper.hidden = toggle.getAttribute('aria-expanded') === 'false'; collectionTitle(); }, 50); }).observe(root, {subtree:true, childList:true});
  }
  function purchaseActions(root) {
    const info = root.querySelector('.product__info-container');
    if (!info) return;
    const price = info.querySelector('[id^="price-"]');
    const wishlist = root.querySelector('.vr-wishlist-product');
    const title = info.querySelector('.product__title');
    if (title && price && title.nextElementSibling !== price) title.after(price);
    const offer = info.querySelector('#mpopupLink');
    const payments = info.querySelector('.vr-product-payments');
    const buttons = info.querySelector('.product-form__buttons');
    const buyNow = buttons?.querySelector('[data-vr-buy-now]');
    const cart = buttons?.querySelector('[name="add"]');
    const shipping = root.querySelector('.vr-shipping-estimate');
    if (buttons && buyNow && cart && payments) {
      buttons.prepend(buyNow); buyNow.after(payments);
      let actions = buttons.querySelector('.vr-product-utility-actions');
      if (!actions) { actions = document.createElement('div'); actions.className = 'vr-product-utility-actions'; }
      actions.remove();
      if (wishlist) {
        const gallery = root.querySelector('.product__media-wrapper media-gallery');
        if (gallery) { gallery.classList.add('vr-gallery-with-favourite'); wishlist.style.margin = '0'; gallery.append(wishlist); }
        const link = wishlist.querySelector('a');
        if (link && !link.hasAttribute('data-vr-wish-product')) {
          link.setAttribute('aria-label', document.documentElement.lang.startsWith('it') ? 'Salva nei preferiti' : 'Save to favourites'); link.title = link.getAttribute('aria-label');
          // Account confirmation is authoritative; a link click is not a save.
          delete link.dataset.vrSelected;
        }
      }
      if (shipping && price) {
        const cartHost = () => root.querySelector('.vr-gallery-with-favourite') || buttons;
        let cartAction = root.querySelector('.vr-cart-price-action');
        if (!cartAction) {
          cartAction = document.createElement('button');
          cartAction.type = 'button'; cartAction.className = 'vr-cart-price-action';
          cartAction.innerHTML = '<span class="vr-cart-price-label"></span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2 2h3l1 4h16l-3 10H8L4 4H2V2zm6 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg>';
          const syncCart = () => {
            const label = cart.querySelector('span')?.textContent.trim() || cart.textContent.trim();
            cartAction.disabled = cart.disabled;
            cartAction.classList.toggle('vr-product-in-cart',cart.classList.contains('vr-product-in-cart'));
            cartAction.setAttribute('aria-label', label); cartAction.title = label;
            cartAction.querySelector('.vr-cart-price-label').textContent = document.documentElement.lang.startsWith('it') && !cart.disabled ? 'Aggiungi\nal carrello' : label;
            cartAction.setAttribute('aria-disabled', String(cart.getAttribute('aria-disabled') === 'true' || cart.disabled));
            cartAction.setAttribute('aria-busy', String(cart.classList.contains('loading')));
            const host = cartHost(); if (!host.contains(cartAction) && host.isConnected) host.append(cartAction);
          };
          cartAction.addEventListener('click', () => { if (!cart.disabled && cart.getAttribute('aria-disabled') !== 'true') cart.click(); });
          new MutationObserver(syncCart).observe(cart, {attributes:true,childList:true,subtree:true});
          new MutationObserver(syncCart).observe(price, {childList:true});
          cartHost().append(cartAction); syncCart();
        }
        if (!cartHost().contains(cartAction)) cartHost().append(cartAction);
        cart.classList.add('vr-cart-original');
        const locale = document.documentElement.lang;
        if (!price.contains(shipping)) price.append(shipping);
        let pickupNote = buttons.querySelector('.vr-pickup-note');
        if (!pickupNote) { pickupNote = document.createElement('p'); pickupNote.className = 'vr-pickup-note'; }
        pickupNote.textContent = locale.startsWith('it') ? 'Per solo ritiro l’arredo si trova nei nostri magazzini a Sulmona (AQ) Italia' : locale.startsWith('fr') ? 'Pour un retrait sur place, le meuble se trouve dans nos entrepôts à Sulmona (AQ), Italie.' : 'For collection only, this piece is located in our warehouses in Sulmona (AQ), Italy.';
        payments.after(pickupNote);
        if (offer) pickupNote.after(offer);
      } else {
        payments.after(cart);
        if (offer) cart.after(offer);
      }
      payments.querySelectorAll('li').forEach(item => {
        const name = item.querySelector('title')?.textContent;
        if (name) item.title = name;
        if (name === 'Klarna') payments.prepend(item);
      });
    }
    if (offer && !info.dataset.vrOfferAligned) {
      info.dataset.vrOfferAligned = 'true';
      let frame;
      const alignOffer = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!root.isConnected) return;
          if (!window.matchMedia('(min-width:990px)').matches) { offer.style.removeProperty('margin-top'); return; }
          const photo = root.querySelector('.product__media-item.is-active .product-media-container');
          if (!photo || !photo.getBoundingClientRect().height) return;
          const current = parseFloat(getComputedStyle(offer).marginTop) || 0;
          const gap = Math.max(16, current + photo.getBoundingClientRect().bottom - offer.getBoundingClientRect().bottom);
          offer.style.setProperty('margin-top', gap + 'px', 'important');
        });
      };
      const gallery = root.querySelector('.product__media-wrapper');
      if (gallery) new ResizeObserver(alignOffer).observe(gallery);
      window.addEventListener('resize', alignOffer, {passive:true});
      document.fonts?.ready.then(alignOffer);
      alignOffer();
    }
  }
  function init() {
    document.querySelectorAll('.vr-product-details').forEach(root => tabs(root, '.vr-details-panel'));
    document.querySelectorAll('product-info').forEach(purchase);
    document.querySelectorAll('product-info').forEach(purchaseActions);
    document.querySelectorAll('product-info').forEach(mobileTitle);
    document.querySelectorAll('.vr-gallery-groups').forEach(groups);
    document.querySelectorAll('product-modal').forEach(lightbox);
    collectionTitle(); filterControls();
    const header = document.querySelector('.section-header'); if (header && !header.dataset.vrObserved) { header.dataset.vrObserved = 'true'; new ResizeObserver(() => document.documentElement.style.setProperty('--vr-header-height', header.offsetHeight + 'px')).observe(header); }
  }
  document.addEventListener('DOMContentLoaded', init, {once:true});
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('popstate', collectionTitle);
  document.addEventListener('change', event => { if (event.target.closest('facet-filters-form')) setTimeout(collectionTitle, 700); });
  if (document.readyState !== 'loading') init();
})();

/* Keep wishlist hearts anchored to the photo, rather than the wider gallery. */
(()=>{
  const inset=12;
  let frame;
  function photoBounds(image,clip){
    const r=image.getBoundingClientRect(),style=getComputedStyle(image);let width=r.width,height=r.height;
    if(style.objectFit==='contain'&&image.naturalWidth&&image.naturalHeight){const scale=Math.min(width/image.naturalWidth,height/image.naturalHeight);width=image.naturalWidth*scale;height=image.naturalHeight*scale;}
    const left=r.left+(r.width-width)/2,top=r.top+(r.height-height)/2;
    return {left:Math.max(left,clip.left),right:Math.min(left+width,clip.right),top:Math.max(top,clip.top),bottom:Math.min(top+height,clip.bottom)};
  }
  function place(heart,host,bounds){
    if(bounds.right-bounds.left<68||bounds.bottom-bounds.top<68)return;
    const parent=host.getBoundingClientRect();const gutter=window.matchMedia('(max-width:749px)').matches?4:inset;heart.style.setProperty('--vr-heart-top',(bounds.top-parent.top+gutter)+'px');heart.style.setProperty('--vr-heart-right',(parent.right-bounds.right+gutter)+'px');
  }
  function layout(){
    const compactNames=window.matchMedia('(max-width:749px)').matches;
    document.querySelectorAll('.vr-product-identity--card .vr-identity-designer[data-vr-designer-full]').forEach(node=>{
      const text=node.firstChild,full=node.dataset.vrDesignerFull,short=node.dataset.vrDesignerShort;
      if(!text||text.nodeType!==3||!full)return;
      if(text.nodeValue!==full+' ')text.nodeValue=full+' ';
      if(compactNames&&short&&short!==full&&node.scrollWidth>node.clientWidth+1)text.nodeValue=short+' ';
    });
    document.querySelectorAll('.vr-wishlist-card').forEach(heart=>{
      const host=heart.parentElement,media=host.querySelector('.card__media'),image=media?.querySelector('img');if(!image||!image.complete||!media.getBoundingClientRect().width)return;
      place(heart,host,photoBounds(image,media.getBoundingClientRect()));
    });
    document.querySelectorAll('.vr-gallery-with-favourite').forEach(gallery=>{
      const heart=gallery.querySelector(':scope>.vr-wishlist-product'),viewer=gallery.querySelector('[id^="GalleryViewer-"]');if(!heart||!viewer)return;
      const clip=viewer.getBoundingClientRect();let best=null,area=0;
      gallery.querySelectorAll('.product__media-item:not([hidden]) .product__media img').forEach(image=>{
        if(!image.complete||!image.getBoundingClientRect().width)return;const b=photoBounds(image,clip),visible=Math.max(0,b.right-b.left)*Math.max(0,b.bottom-b.top);if(visible>area){best=b;area=visible;}
      });
      if(heart.hidden!==!best)heart.hidden=!best;if(best){
        place(heart,gallery,best);
        const compactPhotoActions = window.matchMedia('(max-width:749px)').matches;
        const cartWidth = gallery.querySelector(':scope>.vr-cart-price-action')?.getBoundingClientRect().width || 44;
        heart.style.setProperty('--vr-heart-left',(best.right-gallery.getBoundingClientRect().left-(compactPhotoActions?4:inset)-heart.getBoundingClientRect().width-(compactPhotoActions?0:cartWidth+8))+'px');
        const cart = gallery.querySelector(':scope>.vr-cart-price-action');
        if (cart) {
          const parent = gallery.getBoundingClientRect(), rect = heart.getBoundingClientRect();
          cart.style.setProperty('--vr-cart-photo-top', ((compactPhotoActions?rect.bottom:rect.top)-parent.top)+'px');
          cart.style.setProperty('--vr-cart-photo-left', ((compactPhotoActions?rect.left:rect.right+8)-parent.left)+'px');
        }
        const overlay=gallery.parentElement.querySelector(':scope>.vr-product-media-actions');
        if(overlay){
          const parent=overlay.parentElement.getBoundingClientRect();
          const controlIcon=overlay.querySelector('svg'),heartIcon=heart.querySelector('svg');
          const iconOffset=controlIcon?controlIcon.getBoundingClientRect().top-overlay.getBoundingClientRect().top:0;
          const top=compactPhotoActions&&heartIcon?heartIcon.getBoundingClientRect().top-parent.top-iconOffset:best.top-parent.top+inset;
          overlay.dataset.vrPhotoPositioned='true';overlay.style.setProperty('--vr-media-actions-top',top+'px');overlay.style.setProperty('--vr-media-actions-left',(best.left-parent.left+inset)+'px');
        }
      }
      if(!gallery.dataset.vrHeartObserved){gallery.dataset.vrHeartObserved='true';gallery.addEventListener('scroll',schedule,true);gallery.addEventListener('slideChanged',schedule);new ResizeObserver(schedule).observe(gallery);new MutationObserver(schedule).observe(gallery,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden']});}
    });
  }
  function schedule(){cancelAnimationFrame(frame);frame=requestAnimationFrame(layout);}
  function init(){schedule();new MutationObserver(schedule).observe(document.body,{subtree:true,childList:true});}
  window.addEventListener('resize',schedule,{passive:true});document.addEventListener('load',event=>{if(event.target.tagName==='IMG')schedule();},true);document.addEventListener('shopify:section:load',schedule);document.fonts?.ready.then(schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


/* Keep category filters compatible with Shopify's translated product types. */
(()=>{
  const language=document.documentElement.lang.slice(0,2);
  if(!['it','en','fr'].includes(language))return;
  const groups=[
    {it:['Lampade'],en:['Lamps'],fr:['Lampes']},
    {it:['Accessori'],en:['Accessories'],fr:['Accessoires']},
    {it:['Divani e Poltrone'],en:['Sofas and Armchairs'],fr:['Canapés et fauteuils','Canapés et Fauteuils']},
    {it:['Tavoli'],en:['Tables'],fr:['Tables']},
    {it:['Sedie'],en:['Chairs'],fr:['Chaises']},
    {it:['Mobili'],en:['Furniture'],fr:['Meubles']},
    {it:['Specchi'],en:['Mirrors'],fr:['Miroirs']}
  ];
  function translated(value){
    const group=groups.find(group=>Object.values(group).flat().includes(value));
    if(!group||group[language].includes(value))return [value];
    return group[language];
  }
  function normalize(url){
    if(url.origin!==location.origin||!url.pathname.includes('/collections/'))return false;
    const key='filter.p.product_type',before=url.searchParams.getAll(key);
    if(!before.length)return false;
    const after=[...new Set(before.flatMap(translated))];
    if(JSON.stringify(before)===JSON.stringify(after))return false;
    url.searchParams.delete(key);after.forEach(value=>url.searchParams.append(key,value));return true;
  }
  const current=new URL(location.href);
  if(normalize(current)){location.replace(current.href);return;}
  function repairLink(link){
    if(!link?.href)return;
    const url=new URL(link.href,location.href);
    if(normalize(url))link.href=url.href;
  }
  function repairLinks(){document.querySelectorAll('a[href*="filter.p.product_type"]').forEach(repairLink);}
  document.addEventListener('click',event=>repairLink(event.target.closest('a[href]')),true);
  document.addEventListener('shopify:section:load',repairLinks);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',repairLinks,{once:true});else repairLinks();
})();
